import { TemplateRef } from '@angular/core';
import { PropiedadService } from '../../../services/propiedad.service';
import { MatDialog, MatSelect } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
var PropiedadComponent = /** @class */ (function () {
    function PropiedadComponent(_PropiedadService, _router, store, dialog, _formService, spinner) {
        this._PropiedadService = _PropiedadService;
        this._router = _router;
        this.store = store;
        this.dialog = dialog;
        this._formService = _formService;
        this.spinner = spinner;
        this.rows = [];
        this.direcciones = [];
        this.p = 1;
        this.isopen = false;
        this.rol = new FormControl('', [Validators.required]);
        this.dir = new FormControl('', [Validators.required]);
        this.num = new FormControl('', [Validators.required]);
        this.calles = [];
        this.filteredCalles = new ReplaySubject(1);
        this.buscarCalle = new FormControl();
        this._onDestroy = new Subject();
        this.myControl = new FormControl();
        this.options = [];
        //bandera
        this.rol_dir_encontrada = false;
        this.matcher = new FormService();
        if (!JSON.parse(localStorage.getItem("propiedad"))) {
            localStorage.setItem("propiedad", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("propiedad"));
        }
        this.invalidRol = true;
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
    }
    // ngOnDestroy() {
    //     this._onDestroy.next();
    //     this._onDestroy.complete();
    // }
    PropiedadComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.traerCalles();
        this.filteredOptions = this.dir.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    PropiedadComponent.prototype._filter = function (value) {
        if (value != null) {
            var filterValue_1 = value.toLowerCase();
            return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue_1); });
        }
    };
    PropiedadComponent.prototype.getPropiedad_rol = function () {
        var _this = this;
        //console.log("get propiedad rol()",)
        this.spinner.show();
        this._PropiedadService.getPropiedad(this.rol.value, undefined, undefined, undefined).subscribe(function (response) {
            //console.log("getpropiedadrol response:",response)
            if (response.direcciones) {
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
                _this.spinner.hide();
            }
            else {
                if (response.message) {
                    _this.propiedad.rol = _this.rol.value ? _this.rol.value : '';
                    _this.rol_dir_encontrada = false;
                    _this.spinner.hide();
                    _this.dialog.open(_this.openModalNOROL);
                }
                else {
                    _this.propiedad.rol = response.rol ? response.rol : '';
                    _this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedad.folio = response.folio ? response.folio : '';
                    _this.propiedad.calle = response.calle ? response.calle : '';
                    _this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                    _this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedad.loteo = response.loteo ? response.loteo : '';
                    _this.propiedad.manzana = response.manzana ? response.manzana : '';
                    _this.propiedad.plano = response.plano ? response.plano : '';
                    _this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedad.recordId = response.recordId ? response.recordId : '';
                    _this.rol_dir_encontrada = true;
                    _this.dialog.open(_this.openModal);
                    _this.spinner.hide();
                }
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropiedadComponent.prototype.getPropiedad_por_rol = function (rol, id) {
        var _this = this;
        //console.log("getpropiedad_por_rol")
        this.spinner.show();
        this._PropiedadService.getPropiedad(rol, id, undefined, undefined).subscribe(function (response) {
            //console.log("getpropiedad_por_rol response",response);
            //console.log("response.id",response.id)
            //console.log("response.rol",response.rol)
            if (response.direcciones) {
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
                _this.spinner.hide();
            }
            else {
                if (response.message) {
                    _this.propiedad.rol = _this.rol.value ? _this.rol.value : '';
                    _this.rol_dir_encontrada = false;
                    _this.dialog.open(_this.openModalVerPorRol);
                    _this.spinner.hide();
                }
                else {
                    _this.propiedad.rol = response.rol ? response.rol : '';
                    _this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedad.folio = response.folio ? response.folio : '';
                    _this.propiedad.calle = response.calle ? response.calle : '';
                    _this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                    _this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedad.loteo = response.loteo ? response.loteo : '';
                    _this.propiedad.manzana = response.manzana ? response.manzana : '';
                    _this.propiedad.plano = response.plano ? response.plano : '';
                    _this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedad.recordId = response.recordId ? response.recordId : '';
                    _this.rol_dir_encontrada = true;
                    //console.log("rol_dir_encontrada",this.rol_dir_encontrada);
                    _this.dialog.open(_this.openModalVerPorRol);
                    _this.spinner.hide();
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropiedadComponent.prototype.getPropiedad_dir = function () {
        var _this = this;
        this.spinner.show();
        this._PropiedadService.getPropiedad(undefined, undefined, this.dir.value.trim(), this.num.value.trim()).subscribe(function (response) {
            _this.spinner.hide();
            if (response.direcciones) {
                //console.log("entre en 1")
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
            }
            else {
                if (response.message) {
                    //console.log("entre en 2")
                    //this.propiedad.dir = dir ? dir : '';
                    // this.propiedad.num = num ? num : '';
                    _this.propiedad.calle = _this.dir.value ? _this.dir.value : '';
                    _this.rol_dir_encontrada = false;
                    _this.propiedad.calle_num = _this.num.value ? (_this.num.value === '0' ? '' : _this.num.value) : '';
                    _this.dialog.open(_this.openModalNOROL);
                }
                else {
                    //console.log("entre en 3")
                    _this.propiedad.rol = response.rol ? response.rol : '';
                    _this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedad.folio = response.folio ? response.folio : '';
                    _this.propiedad.calle = response.calle ? response.calle : '';
                    _this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                    _this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedad.loteo = response.loteo ? response.loteo : '';
                    _this.propiedad.manzana = response.manzana ? response.manzana : '';
                    _this.propiedad.plano = response.plano ? response.plano : '';
                    _this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedad.recordId = response.recordId ? response.recordId : '';
                    _this.rol_dir_encontrada = true;
                    _this.dialog.open(_this.openModal);
                    _this.isopen = false;
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
            _this.isopen = false;
        });
    };
    PropiedadComponent.prototype.cleanData = function () {
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
    };
    PropiedadComponent.prototype.savePropiedad = function () {
        $("#dir_modal").modal("hide");
        this.actualRow = localStorage.getItem("propiedad");
        this.rows = JSON.parse(this.actualRow);
        if (this.rol_dir_encontrada) {
            this.rows = [{
                    rol: this.propiedad.rol,
                    id_direcc: this.propiedad.id_direcc,
                    folio: this.propiedad.folio,
                    calle: this.propiedad.calle,
                    calle_num: this.propiedad.calle_num,
                    direccion_completa: this.propiedad.direccion_completa,
                    direc_complemento: this.propiedad.direc_complemento,
                    direc_compl_num: this.propiedad.direc_compl_num,
                    loteo: this.propiedad.loteo,
                    manzana: this.propiedad.manzana,
                    plano: this.propiedad.plano,
                    ubicacion: this.propiedad.ubicacion,
                    recordId: this.propiedad.recordId,
                }];
        }
        else {
            this.rows = [{
                    rol: this.propiedad.rol,
                    id_direcc: this.propiedad.id_direcc,
                    folio: this.propiedad.folio,
                    calle: this.propiedad.calle,
                    calle_num: this.propiedad.calle_num,
                    direccion_completa: this.propiedad.calle + " Nº" + this.propiedad.calle_num,
                    direc_complemento: this.propiedad.direc_complemento,
                    direc_compl_num: this.propiedad.direc_compl_num,
                    loteo: this.propiedad.loteo,
                    manzana: this.propiedad.manzana,
                    plano: this.propiedad.plano,
                    ubicacion: this.propiedad.ubicacion,
                    recordId: this.propiedad.recordId,
                }];
        }
        //console.log("this.rows save propiedad",this.rows)
        localStorage.setItem("propiedad", JSON.stringify(this.rows));
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
        this.dialog.closeAll();
    };
    PropiedadComponent.prototype.savePropiedadMulti = function (direccion) {
        //console.log("save propiedad multi direccion ",direccion)
        $("#dir_modal2").modal("hide");
        this.actualRow = localStorage.getItem("propiedad");
        this.rows = JSON.parse(this.actualRow);
        this.rows = [{
                rol: direccion.rol ? direccion.rol : '',
                id_direcc: direccion.id_direcc ? direccion.id_direcc : '',
                folio: direccion.folio ? direccion.folio : '',
                calle: direccion.calle ? direccion.calle : '',
                calle_num: direccion.calle_num ? (direccion.calle_num == 0 ? '' : direccion.calle_num) : '',
                direccion_completa: direccion.direccion_completa ? direccion.direccion_completa : '',
                direc_complemento: direccion.direc_complemento ? direccion.direc_complemento : '',
                direc_compl_num: direccion.direc_compl_num ? direccion.direc_compl_num : '',
                loteo: direccion.loteo ? direccion.loteo : '',
                manzana: direccion.manzana ? direccion.manzana : '',
                plano: direccion.plano ? direccion.plano : '',
                ubicacion: direccion.ubicacion ? direccion.ubicacion : '',
                recordId: direccion.recordId ? direccion.recordId : ''
            }];
        localStorage.setItem("propiedad", JSON.stringify(this.rows));
        //console.log("save propiedad multi this.rows",this.rows)
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
        this.dialog.closeAll();
    };
    PropiedadComponent.prototype.deletePropiedad = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("propiedad", JSON.stringify(this.rows));
            }
        }
    };
    PropiedadComponent.prototype.traerCalles = function () {
        var _this = this;
        this._PropiedadService.traerCalles().subscribe(function (data) {
            _this.options = data.calles;
        }, function (error) {
            console.log(error);
        });
    };
    return PropiedadComponent;
}());
export { PropiedadComponent };
